import script from "./HeaderContent.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderContent.vue?vue&type=script&setup=true&lang=js"

import "./HeaderContent.vue?vue&type=style&index=0&id=1d55c7dc&scoped=true&lang=css"

import exportComponent from "/Users/wangcaijuan/var/www/oa-show/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d55c7dc"]])

export default __exports__